var map = {
	"./game_full": 315,
	"./game_full.json": 315
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 899;



/*****************
 ** WEBPACK FOOTER
 ** ./src/sources ^\.\/.*$
 ** module id = 899
 ** module chunks = 0
 **/